export default "__VITE_ASSET__d0da438d__"